import React, { ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//Custom Controls
import BaseInputControl from "./BaseInputControl";
import LockAdornment from "./adornments/LockAdornment";
import LinkAdornment from "./adornments/LinkAdornment";

//Types
import { ILinkControlProps } from "@/@types/controls/controls";

function LinkControl(props: ILinkControlProps) {
  // const dialogContext = useContext(DialogContext);

  const { t } = useTranslation();

  const { field, value, onChange, controlMode, linkType, ...otherProps } = props;

  const isReadOnly = controlMode === "view" || (field && field.readonly);
  const disabled = value && value.length > 0 ? false : true;

  const [adornmentIcon, setAdornmentIcon] = useState<ReactNode>(undefined);
  const [inFocus, setInFocus] = useState(false);

  const handleChange = (value: string | number | null, source: string) => {
    onChange(value as string, source);
  }

  const setLinkIcon = () => {
    switch (linkType) {
      case "mail":
        const mailHrefUrl = disabled ? "" : "mailto:" + value;
        setAdornmentIcon(<LinkAdornment linkType={linkType} disabled={disabled} href={mailHrefUrl} />)
        break;
      case "url":
        const urlHref = disabled ? "" : (value !== null ? value : "");
        setAdornmentIcon(<LinkAdornment linkType={linkType} disabled={disabled} href={urlHref} />)        
        break;
      case "link":
        const linkHrefUrl = disabled ? "" : (value !== null ? value : "");
        setAdornmentIcon(<LinkAdornment linkType={linkType} disabled={disabled} href={linkHrefUrl} />)
        break;
    }
  }

  useEffect(() => {
    if (isReadOnly) {
      setAdornmentIcon(<LockAdornment />);
    } else {
      setLinkIcon();
    }
  }, [value])

  const handleFocus = () => {
    setLinkIcon();
    setInFocus(true);
  }

  const handleBlur = () => {
    if (isReadOnly) {
      setAdornmentIcon(<LockAdornment />);
    } else {
      setAdornmentIcon(undefined);
    }
    setInFocus(false);
  }

  const handleMouseEnter = () => {
    if (!inFocus) {
      setLinkIcon();
    }
  }

  const handleMouseLeave = () => {
    if (!inFocus) {
      if (isReadOnly) {
        setAdornmentIcon(<LockAdornment />);
      } else {
        setAdornmentIcon(undefined);
      }
    }
  }

  const InputProps = {
    readOnly: isReadOnly,
    endAdornment: adornmentIcon
  };

  return (
    <BaseInputControl
      field={field}
      controlMode={controlMode}
      {...otherProps}
      onFocus={isReadOnly ? handleFocus : undefined}
      onBlur={isReadOnly ? handleBlur : undefined}
      value={value as string}
      onChange={handleChange}
      inputProps={InputProps}
      onMouseEnter={isReadOnly ? handleMouseEnter : undefined}
      onMouseLeave={isReadOnly ? handleMouseLeave : undefined}
    />
  );
}

export default LinkControl;
